export const childEmailBookingFormFieldName = 'childEmailAddress'
export const childPhoneBookingFormFieldName = 'childPhone'
